<template>
  <div>
    <span
      class="icon icon-device text-icon"
      :class="{ icon_warning: !isConnected, icon_primary: isConnected }"
    >
      {{ isConnected ? $t('src/pages/devices.cardiorecorder') : '—' }}
    </span>
    <span v-if="device" class="text-nowrap">{{ device.model }} - {{ device.serial_number }}</span>
  </div>
</template>

<script>
import http from '@/modules/http'

export default {
  name: 'ConnectedDevice',
  props: {
    deviceId: {
      type: [Number],
      required: false
    }
  },
  data: () => ({
    device: null
  }),
  mounted() {
    this.getDevice()
  },
  computed: {
    isConnected() {
      return Boolean(this.deviceId)
    }
  },
  watch: {
    deviceId() {
      this.getDevice()
    }
  },
  methods: {
    getDevice() {
      if (!this.deviceId) {
        return
      }

      http
        .get('/devices/' + this.deviceId)
        .then(response => {
          this.device = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
